import { connect } from "react-redux";
import { compose } from "redux";
import { RootState } from "store/store";
import AddNewCustomer from "./AddNewCustomer";
import {
    cleanAddNewCustomerData,
    setNewCustomerFormValue,
} from "store/customers/add-new-customer/add-new-customer-actions";
import { fetchCustomerMetadata } from "store/customers/add-new-customer/add-new-customer-thunks";
import { fetchCustomers } from "store/customers/customers-thunks";
import {
    setIsModalOpen,
    setModalLoaderVisibility,
} from "store/common/modal-window/modal-window-slices";
import { getCustomers } from "store/customers/customers-selectors";
import { getRegions } from "store/customers/add-new-customer/add-new-customer-selector";
import { getIsUserPartner } from "store/app-global/app-global-selectors";
import { getAppSettings } from "store/app-settings/app-settings-selectors";

const mapStateToProps = (state: RootState) => {
    return {
        isModalBusy: state.modalWindowReducer.isModalLoaderVisible,
        consents:
            state.addNewCustomersReducer.newCustomer
                .customerAadMasterTenantConsents,
        customerTypes: state.addNewCustomersReducer.customerTypes,
        isAddNewCustomerModalOpen: state.modalWindowReducer.isModalOpen,
        newCustomerFormValue: state.addNewCustomersReducer.newCustomerFormValue,
        regions: getRegions(state),
        newCustomer: state.addNewCustomersReducer.newCustomer,
        customerNames: getCustomers(state),
        isPartner: getIsUserPartner(state),
        appSettings: getAppSettings(state),
    };
};
const AddNewCustomerContainer = compose(
    connect(mapStateToProps, {
        fetchCustomerMetadata,
        fetchCustomers,
        setNewCustomerFormValue,
        cleanAddNewCustomerData,
        setIsModalOpen,
        setModalLoaderVisibility,
    })
)(AddNewCustomer);

export default AddNewCustomerContainer;
